import { useEffect } from 'react';
import { Button, Flex, Result } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate, useRouteError } from 'react-router-dom';
import { errorReporter } from '@/shared/lib/errorReporter';
import { PageHelp } from '@/shared/ui';

/** `errorElement` at the router root (docs/PLAN.md §6) — catches anything a route/loader throws
 *  that `ErrorBoundary` (a render-time-only React boundary) wouldn't. */
export function ErrorPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const error = useRouteError();

  useEffect(() => {
    errorReporter.captureException(error);
  }, [error]);

  return (
    <Flex
      vertical
      align="center"
      justify="center"
      style={{ minHeight: '100vh', padding: 16, background: 'var(--color-bg-layout)' }}
    >
      <Result
        status="error"
        title={t('error.page.title')}
        extra={
          <Button type="primary" onClick={() => void navigate('/')}>
            {t('error.page.backHome')}
          </Button>
        }
      />
      <PageHelp ns="common" page="error" />
    </Flex>
  );
}
